/**
 * WEB-785 (возврат проверки 09.08): ярлык над экраном квиза печатает имя
 * экрана. Когда генерация не придумала осмысленного имени, она оставляет
 * служебное «Screen 9» — и человек видел латиницу среди русских ВОЗРАСТ /
 * ЦЕЛЬ / АНАЛИЗ. Одна выпавшая строка заметнее сплошной непереведённости.
 *
 * Переводить такое имя бессмысленно: «Экран 9» ничем не лучше «Screen 9» —
 * это внутренняя нумерация, а не название раздела, человеку она ничего не
 * сообщает. Служебное имя не показываем вовсе, осмысленное — как раньше.
 *
 * Живёт ЗДЕСЬ, а не в плеере: сторож WEB-967 запрещает кириллицу в исходниках
 * плеера (все видимые строки обязаны приходить из словаря). Здесь кириллица —
 * не показываемый текст, а образец для распознавания того, что пришло из
 * данных, поэтому её место в общей утилите.
 */

/**
 * Имя целиком состоит из служебной нумерации. Проверка строгая (не «содержит»),
 * иначе живое название вроде «Экран приветствия» пропало бы заодно.
 */
const SERVICE_SCREEN_NAME = /^\s*(?:screen|экран)\s*[№#]?\s*\d+\s*$/i; // i18n-allow: образец РАСПОЗНАВАНИЯ имени из данных, а не показываемый текст

/** true — имя стоит показать человеку; false — служебная нумерация или пусто. */
export function isMeaningfulScreenName(name: unknown): name is string {
  return (
    typeof name === 'string' &&
    name.trim().length > 0 &&
    !SERVICE_SCREEN_NAME.test(name)
  );
}
